/**
 * @Author: zhangxiaojian
 * @Date: 2025/7/9
 * @LastEditors: zhangxiaojian
 * @Description CDN配置信息
 **/
const cdnConfig =   {
  mediaxVersion: '3.6.0.2393', // 云雀版本号
  host: 'https://mediax-cdn.xmt.fzyun.cn', // cdn域名
  cdnDir:"mediax/{PASS_CONFIG_APPLICATION}",//cdn指定目录
  release: 'true', // 是否是发版模式，'false'表示非发版模式，'true'表示发版模式 值为字符串格式
}
export default cdnConfig;
